import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Snowflake, Lock, Eye, EyeOff } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!password) {
      toast.error("Bitte Passwort eingeben");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { password });
      // Store password for Basic Auth
      sessionStorage.setItem("adminAuth", btoa(`admin:${password}`));
      toast.success("Login erfolgreich!");
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error("Ungültiges Passwort");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 flex items-center justify-center p-6">
      <Card className="w-full max-w-md border-0 shadow-2xl" data-testid="admin-login-card">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-sky-500/20 flex items-center justify-center">
              <Snowflake className="w-8 h-8 text-sky-400" />
            </div>
          </div>
          <CardTitle className="text-2xl font-semibold text-slate-900" style={{ fontFamily: 'Playfair Display' }}>
            Admin-Bereich
          </CardTitle>
          <p className="text-slate-500 text-sm mt-2">Grömitzer Eiszeit Verwaltung</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Label htmlFor="password" className="text-slate-700">Passwort</Label>
              <div className="relative mt-2">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <Input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Admin-Passwort"
                  className="pl-10 pr-10 h-12 rounded-xl border-slate-200"
                  data-testid="admin-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>
            
            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 rounded-xl bg-sky-500 hover:bg-sky-600 text-white font-semibold"
              data-testid="admin-login-btn"
            >
              {loading ? "Wird angemeldet..." : "Anmelden"}
            </Button>
          </form>
          
          <div className="mt-6 text-center">
            <a href="/" className="text-sm text-slate-500 hover:text-sky-500 transition-colors">
              ← Zurück zur Website
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
